import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import AmountAgencyEditForm from '../../elements/agencies/amounts_form';
import Loading from './../../elements/loading';
import AmountsAdd from './../../elements/agencies/widget/amounts_add';

class AmountsAgenciesEdit extends Component {
	render() {
		const { amounts_agencies, entities} = this.props;
		return (
			amounts_agencies.isFetching || entities.isFetching ? <Loading/>:<AmountAgencyEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.reset('amounts_agencies.edit');
		this.props.amountsAgenciesEdit(this.props.match.params.id);
	}
}

export default BaseLayout(AmountsAgenciesEdit, {
	title:"Editar monto de instancia",
	subnav: {
		icon: 'fa fa-map-marker',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AmountsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/amounts_agencies/edit.jsx